import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import PanelStepEmptyStateContent from '@/components/get-started-panel/PanelStepEmptyStateContent.vue'
  import TrialOrPurchasedCoursesSlider from '@/components/get-started-panel/TrialOrPurchasedCoursesSlider.vue'
  import useIcons from '@/composables/useIcons'
  import useI18n from '@/composables/useI18n'
  import type { PropType } from 'vue'
  import type { GetStartedStepEntity, OnboardingDetails } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PanelStepContent',
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
    onboardingDetails: {
      type: Object as PropType<OnboardingDetails | null>,
      required: true,
    },
    activeStepEntity: {
      type: String as PropType<GetStartedStepEntity>,
      required: true,
    },
    inTrialOrPurchasedCourses: Array as PropType<{ id: string; cardTeaserImageUrl: string; teaserImageUrl: string }[]>,
    stepIsCompleted: Boolean,
    stepEmptyStateTitle: String,
    stepEmptyStateDescription: String,
    totalQuestionsAnsweredPercentage: Number,
    totalQuestionsAnswered: Number,
    stepEmptyStateCTA: String,
  },
  setup(__props) {

const props = __props;

  

  const { heavyThumbsUp } = useIcons()
  const { translateString } = useI18n()

  const completedLessonsOrGuidedQuiz = computed(() => {
    // completed lessons
    if (props.activeStep === 2 && props.onboardingDetails) return props.onboardingDetails.totalLessonsCompleted
    // completed guided quizzes
    return props.onboardingDetails?.guidedQuizzesCompleted
  })

  const completedCountTitle = computed(() => {
    if (props.activeStep === 2) return translateString('homepage.getStartedPanel.completedLessonsAlready')
    return translateString('homepage.getStartedPanel.completedGuidedQuizzesAlready')
  })

  const completedCountDescription = computed(() => {
    if (props.activeStep === 2) return translateString('homepage.getStartedPanel.completedLessonsDescription')
    return translateString('homepage.getStartedPanel.completedGuidedQuizzesDescription')
  })

  const stepVideoUrlDetails = computed(
    () => (videoEntity: GetStartedStepEntity) =>
      props.onboardingDetails?.videoUrlDetails.find((v) => v.videoEntity === videoEntity),
  )

  const stepVideoUrl = computed(() => stepVideoUrlDetails.value(props.activeStepEntity)?.videoUrl)

  const stepVideoUrlThumbnailTimestamp = computed(
    () => stepVideoUrlDetails.value(props.activeStepEntity)?.thumbnailTimestamp || 0,
  )

return { __sfc: true,props, heavyThumbsUp, translateString, completedLessonsOrGuidedQuiz, completedCountTitle, completedCountDescription, stepVideoUrlDetails, stepVideoUrl, stepVideoUrlThumbnailTimestamp, computed, PanelStepEmptyStateContent, TrialOrPurchasedCoursesSlider, useIcons, useI18n }
}

})